<template>
	<v-row>
		<v-col>

			<v-form v-if="this.partner" v-model="formIsValid.place" ref="placeForm">
				<ui-box :form="$refs.placeForm" new-forms>

					<form-title title="Place"></form-title>

					<form-divider inner/>

					<v-row>
						<v-col>
							<venue-select
								v-model="culinary.venue_id"
								:rules="rules.place"
								:venues="venues"
							></venue-select>
						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.menuType" ref="menuTypeForm">

				<ui-box :form="$refs.menuTypeForm" :eager="!!product.id" new-forms>

					<form-title title="What type of item do you want to provide?">
						Choose the type of item you want to provide for this menu.
					</form-title>

					<form-divider inner/>

					<!-- Child Template -->
					<v-row>
						<v-col>
							<v-select
									v-model="selectedCulinaryTemplate"
									class="rounded-lg required"
									hide-details="auto"
									:items="template.childTemplates"
									item-text="name"
									label="Menu Type"
									outlined
									return-object
									:rules="rules.template_id"
							></v-select>
						</v-col>
					</v-row>
					<!-- End: Child Template -->

				</ui-box>

			</v-form>

			<form-divider/>

			<v-form
					v-if="origin === 'partner-portal'"
					v-model="formIsValid.menuType"
					ref="menuTypeForm"
			>

				<ui-box :form="$refs.menuTypeForm" :eager="!!product.id" new-forms>

					<form-title title="Check-In Validation">
						What type of check-in validation would you like?
					</form-title>

					<form-divider inner/>
					<v-row>
						<v-col>
							<v-select
									v-model="culinary.redemption_validation"
									class="rounded-lg required"
									clearable
									:items="checkInValidations"
									item-text="name"
									item-value="id"
									label="Check-in Validation"
									outlined
									:rules="rules.redemption_validation"
							></v-select>
						</v-col>
					</v-row>

				</ui-box>

			</v-form>

			<form-divider/>

			<v-form v-if="origin!='merchant-portal'" v-model="formIsValid.buttonLanguage" ref="buttonLanguageForm" class="mb-8">
				<button-language :refs="$refs" :product="product" :coupon="culinary" :partner="partner" :form-is-valid="formIsValid"/>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.menu" ref="menuForm">

				<ui-box :form="$refs.menuForm" :eager="!!product.id" new-forms>

					<form-title title="Menu"></form-title>

					<form-divider inner/>

					<!-- Menu name -->
					<v-row>
						<v-col>
							<v-text-field
									v-model="culinary.name"
									class="rounded-lg required"
									hint="Ex: Prix Fixe Menu, Special Item, etc."
									label="Menu Name"
									outlined
									persistent-hint
									:rules="rules.name"
							></v-text-field>
						</v-col>
					</v-row>
					<!-- End: Admission name -->

					<!-- Fixed Menu -->
					<v-row>
						<v-col>
							<v-text-field
									v-model="culinary.settings.culinary_menu_title"
									class="rounded-lg required"
									label="Title"
									outlined
									persistent-hint
									:rules="rules.title"
							></v-text-field>
						</v-col>
					</v-row>

					<v-row>
						<v-col class="editor-container">
							<tiptap-vuetify-input
									v-model="culinary.settings.culinary_menu"
									label="Menu"
									:rules="rules.culinary_menu"
							/>
						</v-col>
					</v-row>

					<!-- End: Fixed Menu -->

				</ui-box>

			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.details" ref="detailsForm">

				<ui-box :form="$refs.detailsForm" :eager="!!product.id" new-forms>

					<form-title title="Brief Description & Restrictions"></form-title>

					<form-divider inner/>

					<!-- Description / Restrictions -->
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="culinary.short_information"
									:counter="1250"
									hide-details="auto"
									label="Brief Description"
									outlined
									rows="4"
							/>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<wysiwyg-input
									v-model="culinary.restrictions"
									:counter="1250"
									hide-details="auto"
									hint="If there are no restrictions on use for this offer, leave blank."
									label="Restrictions"
									outlined
									persistent-hint
									rows="4"
							/>
						</v-col>
					</v-row>
					<!-- End: Description / Restrictions -->

				</ui-box>

			</v-form>

			<form-divider v-if="origin=='merchant-portal'"/>

			<v-form v-if="origin=='merchant-portal'" v-model="formIsValid.availability"
							ref="availabilityForm" class="mb-8">

				<ui-box :form="$refs.availabilityForm" :eager="!!product.id" new-forms>

					<form-title title="Product Availability"></form-title>

					<form-divider inner/>

					<v-row>
						<v-col cols="12">

							<!-- Added automatically -->
							<v-switch
									v-model="customFields.bw_add_to_future_passes.value"
									class="mb-4"
									dense
									false-value="No"
									hide-details="auto"
									inset
									label="Yes, include this product in future passes automatically."
									true-value="Yes"
							></v-switch>
							<!-- End: Added automatically -->

						</v-col>
					</v-row>
				</ui-box>
			</v-form>

			<form-divider/>

			<v-form v-model="formIsValid.blackoutDates" ref="blackoutDatesForm" class="mb-8">
				<blackout-dates
						:refs="$refs"
						:product="product"
						:coupon="coupon"
						:form-is-valid="formIsValid"
						:timezone="partner?.timezone || timezone"
				/>
			</v-form>


			<v-form v-model="formIsValid.repeat" ref="repeatForm" class="mb-8">

				<ui-box
					:form="$refs.repeatForm"
					:eager="!!product.id"
					new-forms
				>

					<form-title title="Repeat Usage">
						Determine if the customer can check-in more than once.
					</form-title>

					<form-divider inner/>

					<v-row>
						<v-col cols="12" md="5" lg="4">
							<v-switch
								v-model="culinary.repeat"
								:class="culinary.repeat ? 'mt-3' : 'mb-2 mt-0'"
								dense
								hide-details="auto"
								inset
								label="Is this a repeat use check-in?"
							></v-switch>
						</v-col>
						<v-col cols="12" md="7" lg="8">
							<v-row v-if="culinary.repeat">
								<v-col>
									<v-text-field
										v-model.number="culinary.repeat_delay"
										class="flex-grow-1 rounded-lg required"
										clearable
										hide-spin-buttons
										label="Repeat Delay"
										min="1"
										outlined
										prefix="Every"
										:rules="rules.repeat_delay"
										type="number"
										@wheel.native.prevent
									></v-text-field>
								</v-col>
								<v-col>
									<v-select
										v-model="culinary.repeat_delay_type"
										class="flex-grow-1 rounded-lg required"
										clearable
										:items="['hours', 'days', 'weeks', 'months']"
										label="Repeat Delay Type"
										outlined
										:rules="rules.repeat_delay_type"
									></v-select>
								</v-col>
							</v-row>
						</v-col>
					</v-row>
					
				</ui-box>

			</v-form>

			<form-divider/>

		

			<mobile-pass-preview-modal
					v-if="preview.url"
					:preview-url="preview.url"
					@accept-preview="acceptPreview"
					@reject-preview="rejectPreview"
			></mobile-pass-preview-modal>

			<save-form
					:refs="$refs"
					:is-saving="isSaving"
					new-forms
					save-text="Save & Preview"
					@cancel-action="cancelChanges"
					@save-action="saveChanges"
			></save-form>
		</v-col>
	</v-row>
</template>

<script>
import {culinaryHelpers, productHelpers} from '../helpers';
import {templateHelpers} from '../../../../templateHelpers';

import FormDivider from "../../../../UI/Form/FormDivider.vue";
import TiptapVuetifyInput from '../../../../Forms/TiptapVuetifyInput.vue';
import VenueSelect from '../Shared/VenueSelect.vue';
import BlackoutDates from "@app/Shared/Components/BlackoutDates.vue";
import ButtonLanguage from "../Shared/ButtonLanguage.vue";

export default {
	name: 'CulinaryProductForm',
	components: {
		ButtonLanguage,
		BlackoutDates,
		FormDivider,
		TiptapVuetifyInput,
		VenueSelect
	},
	props: {
		checkInValidations: {
			type: Array,
			default: () => []
		},
		// The incoming product from an edit
		product: {
			type: Object,
			default: () => ({})
		},
		template: {
			type: Object,
			default: () => ({})
		},
		venue: {
			type: Object,
			default: () => ({})
		},
		venues: {
			type: Array,
			default: () => []
		},
		partner: {
			type: Object | null,
			default: null
		},
		returnUrl: {
			type: String,
			default: ''
		},
		origin: {
			type: String,
			default: ''
		},
		timezone: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			formIsValid: {
				menuType: false,
				menu: false,
				details: false,
				availability: false
			},
			culinary: {
				...productHelpers.productFormat(this.product)
			},
			customFields: {
				...productHelpers.customFields(this.origin, 'No')
			},
			isSaving: false,
			preview: {
				product: {},
				url: undefined
			},
			rules: {},
			selectedCulinaryTemplate: productHelpers.getTemplate(this.product, this.template, this.template.childTemplates.map(t => t.id))
		};
	},
	mounted() {
		this.rules = culinaryHelpers.getValidationRules(this.$data);
		templateHelpers.loadCustomFields(this.culinary, this.customFields);
	},
	methods: {
		acceptPreview() {
			productHelpers.acceptPreview(this.culinary, 'Culinary', this.preview, this.getReturnUrl());
		},
		cancelChanges() {
			window.location = this.getReturnUrl();
		},
		getReturnUrl() {
			return productHelpers.getReturnUrl(this.returnUrl, this.partner, this.venue);
		},
		rejectPreview() {
			this.isSaving = false;
			this.preview.url = undefined;
		},
		saveChanges() {
			this.culinary.customFields = Object.values(this.customFields);

			productHelpers.saveChanges(this.isSaving, this.partner, this.venue, this.culinary, this.preview);

		},
		updateCulinaryName() {
			let generatedName = productHelpers.getGeneratedName(this.selectedCulinaryTemplate, this.culinary);
			if(generatedName === 'Product Name') {
				generatedName = '--';
			}

			this.culinary.name = generatedName;
		},
	},
	watch: {
		selectedCulinaryTemplate: {
			handler(newValue) {
				this.culinary.template_id = newValue?.id || this.product.template_id;

				this.updateCulinaryName();
			}
		}
	}
};
</script>
